<template>
  <component
    :is="tag"
    :style="lineClampStyle"
  >
    <slot />
  </component>
</template>



<script>
  // Replacement for the vue-clamp package (v0.4.1), which has no Vue 3 compatible version
  // and is unmaintained. All usages in this codebase are purely presentational — a fixed
  // number of lines clamped with no expand/collapse interaction — so CSS line-clamp is a
  // complete, zero-dependency replacement. The `tag` and `max-lines` props are fully
  // compatible with the original API. The `autoresize` prop is accepted but does nothing;
  // CSS reflow handles resize automatically.
  export default {
    name: 'VClamp',

    props: {
      tag: {
        type: String,
        default: 'span'
      },

      maxLines: {
        type: Number,
        default: null
      },

      // Accepted for API compatibility with vue-clamp, unused — CSS handles resize natively.
      autoresize: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      lineClampStyle() {
        if (!this.maxLines) return {};

        return {
          display: '-webkit-box',
          '-webkit-box-orient': 'vertical',
          '-webkit-line-clamp': this.maxLines,
          overflow: 'hidden'
        };
      }
    }
  };
</script>
